// Client copy of the provider group list.
//
// ⚠️ MUST stay in sync with server/lib/providerGroups.js, which is the
// authority. This is duplicated rather than shared because Create React App
// refuses imports from outside src/, and a 4 item list is not worth an API
// round trip on every modal open. Same tradeoff the codebase already makes
// elsewhere for small shared constants.
//
// ORGANIC means an independent provider with no parent organization. It is a
// real selectable value, not just the absence of one, so staff can record that
// the question was asked and answered.
export const PROVIDER_GROUPS = [
  'Organic',
  'Aqualit Health',
  'Shiloh4Vets',
  'FasPsych',
];

// Only groups in this set expose the notify-email field. Kept as a set rather
// than a boolean on each group so switching another group on later is a one
// line change here plus filling in addresses.
export const GROUPS_WITH_NOTIFICATIONS = ['FasPsych'];

export const groupSupportsNotifications = (group) =>
  GROUPS_WITH_NOTIFICATIONS.includes(group);
